<i18n lang="yaml">
zh:
  dialog_title: "拆书查看"
  dialog_header: "拆书-"
  selected_chapter: "所选章节"
  breakdown_result: "拆书结果"
  refresh_result: "刷新拆书结果"
  retry_failed: "失败章节重试"
  download_result: "下载当前结果"
  download_prefix: "码哩写作拆书-"
  copy_success_console: "成功复制到剪贴板"
  copy_success: "复制成功"
  copy_fail: "复制失败"
  copy_error: "复制时出错"
en:
  dialog_title: "Breakdown Detail"
  dialog_header: "Breakdown-"
  selected_chapter: "Selected Chapter"
  breakdown_result: "Breakdown Result"
  refresh_result: "Refresh Breakdown Result"
  retry_failed: "Retry Failed Chapters"
  download_result: "Download Current Result"
  download_prefix: "Mali Writer Breakdown-"
  copy_success_console: "Copied to clipboard successfully"
  copy_success: "Copy successful"
  copy_fail: "Copy failed"
  copy_error: "Error during copy"
</i18n>
<template>
    <!-- 拆书-查看 弹窗 -->
    <el-dialog
      class="custom-dialog new-task-detail-dialog"
      ref="dialog-detail"
      :visible.sync="showBreakdownDetailDialogFlagV2"
      :append-to-body="true"
      :modal-append-to-body="false"
      :close-on-press-escape="true"
      :withHeader="false"
      :destroy-on-close="true"
      :show-close="true"
      :close-on-click-modal="true"
      :wrapperClosable="true"
      :width="drawerWidth"
      :top="dialogTop"
      @close="closeDetail" >
        <div class="" style="margin-top: 1rem;">
          <h3 style="color: rgba(0,0,0,0.9);">{{$t('dialog_header')}}{{uploadFile.name}}-{{storyTask.storyPrompt&&storyTask.storyPrompt.title}}</h3>
          <div class="d-flex" style="margin-bottom: 10px;" v-if="isMobile">
            <el-button style="" class="mly-border-radius-12" size="mini" type="primary" @click="showSelectedFlag=true" plain>{{$t('selected_chapter')}}</el-button>
            <el-button style="" class="mly-border-radius-12" size="mini" type="primary" @click="showSelectedFlag=false" plain>{{$t('breakdown_result')}}</el-button>
          </div>
          <div class="d-flex">
            <div v-if="(isMobile&&showSelectedFlag)||(!isMobile)" class="detail-left">
              <div class="" style="color: rgba(0,0,0,0.4);">
                {{$t('selected_chapter')}}
              </div>
              <el-tree
                ref="tree"
                :data="treeData"
                node-key="id"
                default-expand-all>
                <div class="custom-tree-node d-flex flex-y-center flex-between"
                  style="font-weight: 400;margin-right: 1rem;font-size: 12px;color: rgba(0,0,0,0.6);"
                  slot-scope="{ node, data }">
                    <span style="width: 120px;color: rgba(0,0,0,0.9);" class="mly-ellipsis" :class="{'el-icon-document': node.level==2, 'el-icon-files': node.level==1}">
                      {{ data?data.chapterTitle:'' }}
                    </span>
                    <span style="display: inline-block;width: 2rem;"></span>
                    <span style="" :class="{'mly-color-paidui': node.data.breakdownState=='SUBMITTED',
                     'mly-color-jinxing': node.data.breakdownState=='RUNNING',
                     'mly-color-wancheng': node.data.breakdownState=='COMPLETED',
                     'mly-color-shibai': node.data.breakdownState=='FAILED', }">
                      {{node.level==2?(node.data.breakdownStateLabel):''}}
                    </span>
                </div>
              </el-tree>
            </div>
            <div v-if="(isMobile&&(!showSelectedFlag))||(!isMobile)" class="detail-right mly-scrollbar" style="flex: 1;" v-html="replaceLineBreaks(breakdownResult)">

            </div>
          </div>
          <div class="d-flex" style="justify-content: flex-end;margin-top: 10px;">
            <el-button style="" class="mly-border-radius-12" size="mini" type="primary" icon="el-icon-refresh-left" @click="handlePageSubtask" plain>{{$t('refresh_result')}}</el-button>
            <el-button v-if="breakdownStateFlag" style="" class="mly-border-radius-12" size="mini" type="primary" icon="el-icon-refresh" @click="handleRetry" plain>{{$t('retry_failed')}}</el-button>
            <el-button style="" class="mly-border-radius-12" size="mini" type="primary" icon="el-icon-download" @click="downloadFile2" plain>{{$t('download_result')}}</el-button>
          </div>
        </div>
    </el-dialog>
</template>
<script>
import * as StorySubtaskApi from '@/api/storysubtask'
import * as StoryTaskApi from '@/api/storytask'
import { mapState, mapMutations} from 'vuex'
export default {
  name: 'BreakdownDetail',
  props: {
    enums: {
      type: Object,
      default: {ArticleTypeEnum: []}
    },
    storyTask: {
      type: Object,
      default: {}
    },
  },
  components: {

  },
  data() {
    return {
      treeData: [],
      breakdownResult: '',
      breakdownStateFlag: false,
      showSelectedFlag: true
    }
  },
  mounted() {
    console.log('breakdown detail');
    window.addEventListener('resize', this.forceUpdate);
    this.handlePageSubtask();
  },
  computed: {
    ...mapState(['user', 'uploadFile', 'showBreakdownDetailDialogFlagV2']),
    drawerWidth() {
      return window.innerWidth <= 768 ? '100%' : window.innerWidth <= 1200 ? '80%' : '60%';
    },
    isMobile() {
      return window.innerWidth < 768;
    },
    dialogTop() {
      return window.innerWidth <= 768 ? "5vh" : '5vh';
    },
    dialogTitle () {
      return this.$t('dialog_title')
    },
    showHeader() {
      return window.innerWidth <= 768
    },
  },
  created() {
    console.log('created');
  },
  methods: {
    ...mapMutations(['setStory', 'setShowBreakdownDetailDialogFlagV2']),
    closeDetail(){
      this.setShowBreakdownDetailDialogFlagV2(false);
    },
    downloadFile2() {
      const filename = this.uploadFile.name
      const text = this.breakdownResult
      var FileSaver = require('file-saver');
      var blob = new Blob([text], {type: "text/plain;charset=utf-8"});
      let downloadName = this.storyTask.storyPrompt&&this.storyTask.storyPrompt.title;
      FileSaver.saveAs(blob, this.$t('download_prefix')+filename+"-"+downloadName+".txt");
    },
    replaceLineBreaks(str) {
      return str?str.replace(/\\n/g, '\n').replace(/\n/g, '<br>'):"";
    },
    handleRetry() {// result
      StoryTaskApi.update({id: this.storyTask.id, retryFlag: true, breakdownState: 'SUBMITTED'}).then(res => {
        this.$parent.handlePageTask();
        this.closeDetail()
      });
    },
    handlePageSubtask(){
      let taskId = this.storyTask.id
      if(!taskId) {
        return false;
      }
      StorySubtaskApi.page({taskId, size: 5000}).then(res => {
        let result = res.data.data;
        console.log('uploadFile', this.uploadFile)
        if(res.data.code == 0){
          if(result.total > 0){
            let parent = {
              chapterTitle: this.uploadFile.name,
              id: '0'
            }
            this.$set(parent, 'children', result.records);
            this.treeData = []
            this.treeData.push(parent)
            // result
            // 使用 map 方法提取所有的 'breakdownResult' 值
            const breakdownResults = result.records.map(item => item.breakdownResult);
            const breakdownStates = result.records.filter(item => item.breakdownState == 'FAILED');
            this.breakdownStateFlag = breakdownStates.length>0
            console.log('breakdownResults', breakdownResults, 'breakdownStates', breakdownStates)
            // 使用 join 方法将提取的值拼接成一个字符串
            this.breakdownResult = breakdownResults.join('\n');
          }else{
            console.log('无章节数据')
          }
        }
      })
    },
    forceUpdate() {
      this.$forceUpdate(); // 强制重新渲染，以更新计算属性
    },
    copyTextToClipboard(item) {

      const textArea = document.createElement('textarea');
      textArea.value = item;
      textArea.style.position = 'fixed';  // 防止出现滚动条
      document.body.appendChild(textArea);
      textArea.focus();
      textArea.select();
      try {
        const successful = document.execCommand('copy');
        if (successful) {
          console.log(this.$t('copy_success_console'));
          this.$message.success(this.$t('copy_success'));
        } else {
          this.$message.error(this.$t('copy_fail'));
          console.error(this.$t('copy_fail'));
        }
      } catch (err) {
        this.$message.error(this.$t('copy_error'));
        console.error(this.$t('copy_error'));
      }
      document.body.removeChild(textArea);
    },
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.forceUpdate);
  },
}
</script>

<style scoped lang="scss">

/deep/ .el-dialog__header {
  padding: 0;
}
/deep/ .el-form--label-top .el-form-item__label {
  padding: 0;
  font-weight: normal;
}
/deep/ .vmt__nav__items .vmt__nav__item{
  font-size: 14px;
}
.tab-item-content {
  margin-top: 1rem;
  margin-bottom: 1rem;
  height: 50vh;
  background: rgba(206,208,218,0.19);
  border-radius: 16px 16px 16px 16px;
  padding: 1rem;
  font-size: 14px;
  line-height: 28px;
  text-align: justify;
  overflow-y: auto;
  overflow-x: hidden;
}
.tab-item-copy {
  padding: .5rem 1rem;
  color: #0052D9;
  border-radius: 6px;
  width: 4rem;
  float: right;
  border: 1px solid #0052D9;
}
.tab-item-copy:hover {
  background-color: rgba(0, 0, 0, 0.11);
}
/* 全局滚动条轨道的padding */
.mali-scrollbar::-webkit-scrollbar-track {
  background-color: transparent;
  // padding: 20px 0; /* 上下padding */
  margin: 1rem 0;
}

/* 滚动条的样式 */
.mali-scrollbar::-webkit-scrollbar {
  width: 8px;
  margin: 1rem 0;
  background-color: transparent;
}

.mali-scrollbar::-webkit-scrollbar-thumb {
  background-color: rgba(0, 0, 0, 0.1);
}
.detail-right {
  background: rgba(206,208,218,0.1);
  border-radius: 16px 16px 16px 16px;
  padding: 1rem;
  line-height: 1.5rem;
  overflow-y: scroll;
  height: 80vh;
}
</style>
